import { render, staticRenderFns } from "./ProductsSingleCategory.vue?vue&type=template&id=01e8dd75&scoped=true&"
import script from "./ProductsSingleCategory.vue?vue&type=script&lang=js&"
export * from "./ProductsSingleCategory.vue?vue&type=script&lang=js&"
import style0 from "./ProductsSingleCategory.vue?vue&type=style&index=0&id=01e8dd75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e8dd75",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VPagination,VTextField})
